import { Component, OnInit, Inject, OnDestroy } from "@angular/core";
import { TranslocoService } from "@ngneat/transloco";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Store, select } from "@ngrx/store";
import { userDetailsPayload } from "src/app/app-store/user/user.selector";
import { Subscription } from "rxjs";
import { IComplaince } from "src/app/models/assesment";

export interface DialogData {
  asessmentDetails: IComplaince[];
  assessmentResult: number;
  isWorkFromHome?: boolean;
}

@Component({
  selector: "app-health-exposure-instructions",
  templateUrl: "./health-exposure-instructions.component.html",
  styleUrls: ["./health-exposure-instructions.component.css"],
})
export class HealthExposureInstructionsComponent implements OnInit, OnDestroy {
  title: string;
  isNext: boolean;
  result = this.data.assessmentResult;
  mobileImage = "assets/images/checkout_mobile_img.png";
  desktopImage = "assets/images/checkout_img.png";
  userDetailSubscription: Subscription;
  imageLoading = true;

  constructor(
    public dialogRef: MatDialogRef<HealthExposureInstructionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private translocoService: TranslocoService,
    private store: Store
  ) {}

  ngOnInit(): void {
    this.title = this.translocoService.translate(
      "Health Exposure Instructions Acknowledgement"
    );
    this.userDetailSubscription = this.store
      .pipe(select(userDetailsPayload))
      .subscribe((response) => {
        if (response.preferredLanguage !== "English") {
          this.mobileImage = "assets/images/checkout_mobile_img.png";
          this.desktopImage = "assets/images/checkout_img.png";
        }
      });

      if(this.data.isWorkFromHome){
        this.onNext();
      }
  }
  setLoaded() {
    this.imageLoading = false;
  }
  onClose() {
    this.dialogRef.close({ healthStatus: this.result, id: 1 });
  }
  onSubmit() {
    this.dialogRef.close({ healthStatus: 1, id: 1 });
  }
  onNext() {
    this.isNext = true;
    this.title = this.translocoService.translate(
      "Covid-19 Life Saving Rules Acknowledgement"
    );
  }
  ngOnDestroy() {
    if (this.userDetailSubscription) {
      this.userDetailSubscription.unsubscribe();
    }
  }
}
